import React, { useCallback, useState } from "react";
import { Button, ModalProps } from "antd";
import CommonModal from "./CommonModal";
import { useAppDispatch } from "../../utils/hooks/hooks";

interface ConfirmModalProps extends ModalProps {
  titleName?: string;
  close?: any;
  data: any;
  callApi?: any;
}

/**
 * Renders a confirmation modal component for activating or deactivating a record.
 *
 * @param {ConfirmModalProps} props - The props for the confirmation modal component.
 * @param {string} props.titleName - The name of the record to be activated/deactivated.
 * @param {function} props.close - The function to close the modal.
 * @param {object} props.data - The data object containing the record's id and status.
 * @param {function} props.callApi - The function to call the API for activating/deactivating the record.
 * @param {Rest} props.rest - The rest of the props for the modal component.
 * @return {ReactElement} The rendered confirmation modal component.
 */
const ConfirmModal: React.FC<ConfirmModalProps> = ({
  titleName,
  close,
  data,
  callApi,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const [saving, setSaving] = useState<boolean>(false);

  const onYesClick = useCallback(() => {
    setSaving(true);
    dispatch(callApi(data?.id, data?.status))
      .then(() => {
        close();
      })
      .finally(() => setSaving(false))
      .catch((e: any) => e);
  }, [data]);

  return data ? (
    <CommonModal
      className="deleteModal"
      title={`${data?.status ? "Activate" : "Deactivate"} ${titleName}?`}
      open={data ? true : false}
      onCancel={close}
      footer={[
        <Button key="2" htmlType="button" className="cancelBtn" onClick={close}>
          No
        </Button>,
        <Button
          key="1"
          htmlType="button"
          type="primary"
          loading={saving}
          onClick={onYesClick}
        >
          Yes
        </Button>,
      ]}
      {...rest}
    >
      <div className="deleteNote">
        Are you sure you want to {data?.status ? "Activate" : "Deactivate"}?
      </div>
    </CommonModal>
  ) : (
    <></>
  );
};
export default ConfirmModal;
